var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTwitterFooter = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#svg_0a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#75777B",
    d: "M6.857 3.2C4.84 3.2 3.2 4.84 3.2 6.857v18.2858C3.2 27.16 4.84 28.8 6.857 28.8h18.2858c2.0172 0 3.6572-1.64 3.6572-3.6572V6.8571C28.8 4.84 27.16 3.2 25.1428 3.2zM23.8343 8l-5.9314 6.7771L24.88 24h-5.4629l-4.2743-5.5943L10.2457 24H7.5314l6.3428-7.2515L7.1828 8h5.6l3.8686 5.1142L21.12 8zm-2.16 14.3771-9.7085-12.84h-1.6172l9.8172 12.84h1.5085"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "svg_0a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTwitterFooter);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/twitter-footer.4bcf43dbb7a50e9330aadee3f2183098.svg";